<template>
  <v-card flat>
    <v-card-title class="subtitle-1 pa-0 ma-0">
      <span>Unidades ({{ value.unidades.length }} selecionada(s))</span>
      <v-switch
        v-model="value.habilitado"
        color="secondary"
        class="ml-4"
        dense
      />
    </v-card-title>
    <v-card-text
      v-show="value.habilitado"
      class="pa-0 ma-0"
    >
      <v-row>
        <v-col cols="12">
          <app-treeview
            :key="value.macro"
            :value="treeview"
            :nos="unidadesMacro"
            :lista="unidades"
            @return="(value) => sincronize(value)"
          />
        </v-col>
      </v-row>
      <slot name="children" />
    </v-card-text>
  </v-card>
</template>

<script>
import AppTreeview from '@/components/core/AppTreeview';

export default {
  name: 'FiltroUnidade',

  components: { AppTreeview },

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        unidades: [],
        lista: [],
        comissao: false,
        macro: false,
      }),
    },
  },

  data() {
    return {
      treeview: {
        selecionado: [],
        agruparPor: 'unidadePai.id',
        expandir: false,
        todos: false,
        resumir: false,
        search: '',
        tipo: 'independent',
      },
      disable: {
        type: Boolean,
        default: false,
      },
    };
  },

  computed: {
    unidades() {
      let unidades;
      if (this.value.macro) {
        unidades = [...this.unidadesMacro];
      } else {
        unidades = [...this.value.lista];
      }
      return unidades.map((u) => ({
        id: u.id,
        nome: `${u.sigla} - ${u.nome}`,
        unidadePai: u.unidadePai,
      }));
    },
    unidadesMacro() {
      if (this.value.comissao) {
        return this.value.lista
          .filter((u) => !u.unidadePai)
          .sort((a, b) => a.sigla.localeCompare(b.sigla))
          .map((u) => ({
            id: u.id,
            nome: `${u.sigla} - ${u.nome}`,
            unidadePai: u.unidadePai,
          }));
      }
      return this.value.lista.filter((u) => u.id === this.$store.state.auth.unidade.id);
    },
  },

  watch: {
    'value.habilitado': function (value) {
      if (!value) {
        this.setDefault();
      }
    },
    'value.macro': function (value) {
      this.treeview.resumir = value;
      this.treeview.todos = false;
      this.treeview.selecionado = [];
      this.value.unidades = [];
    },
    disable(value) {
      if (value) {
        this.value.habilitado = false;
      }
    },
  },

  methods: {
    sincronize(data) {
      this.value.unidades = this.value.lista.filter((u) => data.some((u2) => u2.id === u.id));
    },
    setDefault() {
      this.treeview.selecionado = [];
      this.treeview.expandir = false;
      this.treeview.todos = false;
      this.treeview.resumir = false;
      this.treeview.search = '';
    },
  },
};
</script>
